import React, { Children, useState } from "react";

import { useTranslation } from "utils";

import { Button, Flex, Icon } from "components";

export type CarouselDottedProps = {
  className?: string;
  nextButtonEnabled?: boolean;
  nextButtonDataTestId?: string;
  backButtonDataTestId?: string;
  children?: React.ReactNode;
  onFinish?: () => void;
};

export const CarouselDotted = ({ nextButtonEnabled, children, className, nextButtonDataTestId, backButtonDataTestId, onFinish }: CarouselDottedProps) => {
  const { t } = useTranslation("cropExplorer");
  const [currentPosition, setCurrentPosition] = useState<number>(0);
  const items = Children.toArray(children).filter((child) => child !== null);
  const count = items.length;

  const onBack = () => {
    if (currentPosition === 0) return;
    setCurrentPosition(currentPosition - 1);
  };
  const onNext = () => {
    if (currentPosition === count - 1) {
      onFinish?.();
      return;
    }
    setCurrentPosition(currentPosition + 1);
  };

  return (
    <Flex className={`carousel-dotted container ${className}`} vertical justify="space-between">
      <Flex className="content">{items[currentPosition]}</Flex>
      <Flex justify="space-between" align="center">
        <div>
          <Button
            dataTestId={backButtonDataTestId}
            className="carousel-dotted back-button"
            type="text"
            size="small"
            onClick={onBack}
            style={{
              visibility: `${currentPosition > 0 ? "visible" : "hidden"}`,
              transition: "visibility 0s",
            }}
          >
            {t("onboardingModal.back")}
          </Button>
        </div>
        <div>
          {items.length !== 1 &&
            items.map((child, index) => (
              <Icon key={index} className={`carousel-dotted step-indicator ${index === currentPosition ? "active" : ""}`} iconName="tabler/point" size="s" />
            ))}
        </div>
        <div>
          <Button dataTestId={nextButtonDataTestId} type="primary" size="small" onClick={onNext} disabled={nextButtonEnabled} style={{ width: "6rem" }}>
            {currentPosition === count - 1 ? t("onboardingModal.confirm") : t("onboardingModal.continue")}
          </Button>
        </div>
      </Flex>
    </Flex>
  );
};
